import api from "./api";
import func from "./func";

let albums = {};
let optionCates = null;

export default {
    v1: {
        album: {
            async detail(id) {
                if (!func.isDefined(albums[id])) {
                    albums[id] = await api.v1.album.detail(id);
                }
                return albums[id];
            },
            setInfo: (id, args) => api.v1.album.setInfo(id, args).then(() => delete albums[id]),
            setConfig: (id, args) => api.v1.album.setConfig(id, args).then(() => delete albums[id]),
            setCopyright: (id, args) => api.v1.album.setCopyright(id, args).then(() => delete albums[id]),
            delete: (id, code) => api.v1.album.delete(id, code).then(() => delete albums[id]),
            folder: require("./cache/folder_v1").default,
            member: require("./cache/member_v1").default,
        },
        option: {
            async cates() {
                if (optionCates === null) {
                    optionCates = await api.v1.option.cates();
                }
                return optionCates;
            }
        },
    }
}
